import { render } from "./ActionHistoryPage.vue?vue&type=template&id=39c700a8&scoped=true&ts=true"
import script from "./ActionHistoryPage.vue?vue&type=script&lang=ts"
export * from "./ActionHistoryPage.vue?vue&type=script&lang=ts"

import "./ActionHistoryPage.vue?vue&type=style&index=0&id=39c700a8&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c700a8"]])

export default __exports__